import axios from "@lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export interface Inputs {
  name: string;
  colorScheme: string;
  active?: boolean;
  type?: string;
}

interface UseSaveTagProps {
  tagId?: string;
  onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveTag = ({ tagId, onSuccess, onError }: UseSaveTagProps) => {
  const queryClient = useQueryClient();
  const {
    isPending,
    isError,
    error,
    mutate: onSaveTag,
  } = useMutation({
    mutationFn: async (data: Inputs) => {
      if (tagId) return axios.patch(`/tags/${tagId}`, data);
      return axios.post("/tags", data);
    },
    onSuccess: ({ data: { tag } }) => {
      if (tagId)
        queryClient.invalidateQueries({
          queryKey: ["tag", tagId],
        });
      if (onSuccess) onSuccess(tag);
    },
    onError,
  });

  return { onSaveTag, isPending, isError, error };
};
